export const ROUTES = {
  ACTIONS: '/actions',
  ACTIONS_TO_BUSINESS: '/actions/to-business',
  ACTIONS_DELEGATE_LOGIN: '/actions/delegate-login',
};
